import { Component, OnInit } from '@angular/core';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { ActivatedRoute, Router } from '@angular/router';
import { GbgrundstueckService } from 'app/core/gb-api';
import { TimepointService } from 'app/core/services/timepoint.service';
import { AppConfigService } from 'app/core/services/app-config.service';
import { ListLoaderInfiniteBuilder } from 'app/shared/components/list-loader/list-loader-infinite';
import { map, tap } from 'rxjs/operators';
import { AbstractRangregelungVm, RangregelungViewmodelService } from 'app/core/services/rangregelung-viewmodel.service';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { RangregelungTableComponent } from '../../../shared/widgets/rangregelung-table/rangregelung-table.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-rangregelungen-rubrik',
  templateUrl: './rangregelungen-rubrik.component.html',
  styleUrls: ['./rangregelungen-rubrik.component.scss'],
  imports: [RubrikComponent, RangregelungTableComponent, TranslatePipe]
})
export class RangregelungenRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  loader: ListLoader<AbstractRangregelungVm>;
  ersterfassungUebergeben: boolean;

  private readonly CHUNK_SIZE = 5;
  private readonly PAGE_SIZE = undefined;
  private readonly CURRENT_PAGE = 1;

  constructor(
    private rangregelungViewmodelService: RangregelungViewmodelService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected loadData() {
    this.loader = this.createStandardrechtLoader();
  }

  private createStandardrechtLoader(): ListLoader<AbstractRangregelungVm> {
    const observable = (offset: number, limit: number) => {
      return this.rangregelungViewmodelService.loadSichtByGrundstueckId(this.gsId, offset, limit, this.subscriptions).pipe(
        tap((res) => (this.ersterfassungUebergeben = res.ersterfassungUebergeben)),
        map((res) => res.entries)
      );
    };
    const loader = ListLoaderInfiniteBuilder.builder<AbstractRangregelungVm>()
      .setLookupItemFunc(observable)
      .setChunkSize(this.CHUNK_SIZE)
      .setPageSize(this.PAGE_SIZE)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPublishItemsWhenAllLoaded(true)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
